import type { VAxios } from '../../define/axios/Axios';

import { TranslateParams, TranslateRes } from '../../entities/cc/translate.entities';

/**
 * 翻译接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  //#region 翻译接口
  // 翻译
  translate: (params: TranslateParams) =>
    defHttp.post<TranslateRes>({ url: `/aiad/translations`, params }),
  // 单句翻译，处理标点符号
  translateSingle: (params: TranslateParams) =>
    defHttp.post<TranslateRes>({ url: `/aiad/translations/single`, params }),
  //#endregion
});
